import React from 'react'
import reactStamp from 'react-stamp'
import RaisedButton from 'material-ui/RaisedButton'
import FlatButton from 'material-ui/FlatButton'
import TextField from 'material-ui/TextField';
import Background from '../Background'
import Links from '../../router/links'

import './login.css'

export default reactStamp(React).compose({

    init(){
        this.handleLoginChange = this.handleLoginChange.bind(this);
        this.handlePasswordChange = this.handlePasswordChange.bind(this);
        this.handleSignUpOnClick = this.handleSignUpOnClick.bind(this);
    },

    componentWillMount(){
        this.props.handleLoginTextField((sessionStorage.getItem("email") != undefined ) ? sessionStorage.getItem("email") : "");
    },

    render(){
        let badCredentialsClass;
        if (this.props.err) {
            badCredentialsClass = "showErr"
        } else {
            badCredentialsClass = "err"
        }

        return (
            <div>
                <Background />
                <div className="login-container">

                    <form className="login-form" onSubmit={this.props.handleUserLogin}>
                        <h2 className="login">Sign in</h2>
                        <TextField
                            className="login-element"
                            floatingLabelText="Email"
                            onChange={this.handleLoginChange}
                            defaultValue={(sessionStorage.getItem("email") != undefined ) ? sessionStorage.getItem("email") : ""}
                        /><br />
                        <TextField
                            className="login-element"
                            floatingLabelText="Password"
                            type="password"
                            onChange={this.handlePasswordChange}
                        />
                        <br />
                        <br />
                        <p className={badCredentialsClass}>Bad credentials!</p>
                        <RaisedButton
                            type="submit"
                            className="login-element button-login"
                            label="login"
                            primary={true}
                            onMouseDown={this.props.handleUserLogin}
                        />
                        <FlatButton
                            className="signup-button"
                            label="Don't have an account?"
                            onTouchTap={this.handleSignUpOnClick}
                        />
                    </form>
                </div>
            </div>
        )
    },

    handleLoginChange(e){
        e.preventDefault();
        this.props.handleLoginTextField(e.target.value)
    },

    handlePasswordChange(e){
        e.preventDefault();
        this.props.handlePasswordTextField(e.target.value)
    },

    handleSignUpOnClick(){
        Links.toSignUp()
    }

});


/** WEBPACK FOOTER **
 ** ./src/app/components/Login/index.js
 **/